// src/components/SafeHtml/index.jsx
import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

// 白名单标签：只允许基础排版和安全标签
const ALLOWED_TAGS = [
  'p',
  'div',
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'ul',
  'ol',
  'li',
  'a',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
];

// 白名单属性：只允许 href、target、rel
const ALLOWED_ATTR = ['href', 'target', 'rel', 'class'];

/**
 * 安全渲染 HTML 内容
 * 使用 DOMPurify 清理危险标签 + 白名单策略
 */
const SafeHtml = ({ content, className }) => {
  if (!content) return null;

  // DOMPurify 清理危险标签，防止 XSS 攻击
  const cleanContent = DOMPurify.sanitize(content, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target'], // 允许 target="_blank"
  });

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: cleanContent }}
    />
  );
};

SafeHtml.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
};

export default SafeHtml;
